export const CONTACT_CHANNEL_TYPE_BILLING_ADDRESS = 'BILLING_ADDRESS';
export const CONTACT_CHANNEL_TYPE_SHIPPING_ADDRESS = 'SHIPPING_ADDRESS';
